<div class="nova-font-style" [hidden]="initialLoading">
  <div class="top-margin-15"></div>
  <h2>Cutoff Notices</h2>
  <div class="row">
    <div class="col s12 m12 l12 xl12 padding-0">
      <div class="disclaimer-note"><span [innerHTML]="config.CutoffNoticesMsg"></span></div>
    </div>
    <div class="col s12 m12 l12 xl12 top-margin-10 padding-0">
      <kendo-grid [kendoGridBinding]="gridData" id="cutoff-grid" [pageSize]="state.take" [resizable]="true"
        [skip]="state.skip" [pageable]="true" [navigable]="false" [sort]="state.sort" [sortable]="true">
        <!-- Mobile View -->
        <kendo-grid-column media="(max-width: 772.98px)" title="Details">
          <ng-template kendoGridCellTemplate let-dataItem>
            <dl>
              <dd>
                <div class="align-left">
                  <span class="bold">SSN4:</span>
                  <span> {{ dataItem.ssn4 }}</span>
                </div>
              </dd>
              <dd>
                <div class="align-left">
                  <span class="bold">Last Name:</span>
                  <span> {{ dataItem.lastName }}</span>
                </div>
              </dd>
              <dd>
                <div class="align-left">
                  <span class="bold">First Name:</span>
                  <span> {{ dataItem.firstName }}</span>
                </div>
              </dd>
              <dd>
                <div class="align-left">
                  <span class="bold">MI:</span>
                  <span> {{ dataItem.middleInitial }}</span>
                </div>
              </dd>
              <dd>
                <div class="align-left">
                  <span class="bold">Effective Date:</span>
                  <span> {{ dataItem.effectiveDate | date: 'MM/dd/yyyy' }}</span>
                </div>
              </dd>
              <dd>
                <div class="align-left">
                  <span class="bold">Date Processed:</span>
                  <span> {{ dataItem.processDate | date: 'MM/dd/yyyy' }}</span>
                </div>
              </dd>
            </dl>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column media="(min-width: 773px)" field="ssn4" title="SSN4" [headerClass]="{'align-center': true}" [width]="80">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="align-center">
              <span>
                {{dataItem.ssn4}}
              </span>
            </div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column media="(min-width: 773px)" field="lastName" title="Last Name" [width]="160">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="align-text">
              <span>
                {{dataItem.lastName}}
              </span>
            </div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column media="(min-width: 773px)" field="firstName" title="First Name" [width]="160">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="align-text">
              <span>
                {{dataItem.firstName}}
              </span>
            </div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column media="(min-width: 773px)" field="middleInitial" title="MI" [width]="60"
          [headerClass]="{'align-center': true}" [width]="80">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="align-center">
              <span>
                {{dataItem.middleInitial}}
              </span>
            </div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column media="(min-width: 773px)" field="effectiveDate" title="Effective Date"
          [headerClass]="{'align-date': true}" [width]="130">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="align-date">
              {{dataItem.effectiveDate | date: 'MM/dd/yyyy'}}
            </div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column media="(min-width: 773px)" field="processDate" title="Date Processed"
          [headerClass]="{'align-date': true}" [width]="130">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="align-date">
              {{dataItem.processDate | date: 'MM/dd/yyyy'}}
            </div>
          </ng-template>
        </kendo-grid-column>
      </kendo-grid>
    </div>
  </div>
</div>
<app-notification-loading></app-notification-loading>
